<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>


<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <input type="hidden" [id]="(id === null ? name : id)" [name]="name" [value]="value">
    <input class="autocomplete-field" type="text" #field autocomplete="off"
        [ngClass]="(readOnly ? 'form-control disabled' : 'form-control')" [disabled]="readOnly"
        [placeholder]="placeholder" (keyup)="componentKeyUp($event)" (focus)="carregarLista(true)"
        (focusout)="ocultarLista()" />
    <!--<datalist #dataList id="items" >
        <option *ngFor="let item of listItems" [value]="item.text" [id]="item.value">
        </option>
    </datalist>-->
    <div #resultado [ngClass]="(this.exibeLista() ? 'tem-resultado' : '')"
        class="auto-complete-resultados overflow-auto">
        <ul>
            <li [ngClass]="(i === this.focusedIndex ? 'focused' : '')" *ngFor="let item of listItems; let i = index"
                (click)="selecionarItem(item)">
                <div *ngIf="this.dadosSubordinacao; then subordinacao else simples"></div>

                <ng-template #subordinacao>
                    <span class="small"><b>{{ item.complementar.descricaoPrincipal }}</b></span><br />
                    <span class="small">{{ item.nome }}</span>
                </ng-template>

                <ng-template #simples>
                    {{ item.nome }}
                </ng-template>

            </li>
        </ul>
    </div>
</ng-template>
<ng-template #showSpan>
    <span type="text" #field [id]="(id === null ? name : id)">
        {{getItemText()}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>

<div *ngIf="!detailMode && required">
    <app-input-feedback [hidden]="!validateInvalid()" [feedbackMessage]="'O valor selecionado é inválido'">
    </app-input-feedback>
</div>